import React from "react";
import AppRoute from "./Routes/AppRoute";
import './App.css'
function App() {
  return (
    <AppRoute />
  );
}

export default App;
